import { __assign, __awaiter, __extends, __generator } from "tslib";
import React from 'react';
import { utils } from 'pro-gallery-lib';
import ImageItem from '../imageItem';
import PlayBackground from '../../svgs/components/play_background';
import PlayTriangle from '../../svgs/components/play_triangle';
import VideoItemPlaceholder from './videoItemPlaceholder';
var videoControls = [
    React.createElement("i", { key: "play-triangle", "data-hook": "play-triangle", className: 'gallery-item-video-play-triangle play-triangle ' },
        React.createElement(PlayTriangle, null)),
    React.createElement("i", { key: "play-bg", "data-hook": "play-background", className: 'gallery-item-video-play-background play-background ' },
        React.createElement(PlayBackground, null)),
];
var VideoItemWrapper = /** @class */ (function (_super) {
    __extends(VideoItemWrapper, _super);
    function VideoItemWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.shouldPlayVideo = _this.shouldPlayVideo.bind(_this);
        _this.createVideoItemPlaceholder = _this.createVideoItemPlaceholder.bind(_this);
        _this.state = { VideoItemLoaded: false };
        return _this;
    }
    VideoItemWrapper.prototype.shouldPlayVideo = function () {
        var _a = this.props.styleParams, videoPlay = _a.videoPlay, itemClick = _a.itemClick;
        var hasLink = this.props.hasLink;
        if (this.props.isVideoPlaceholder) {
            return false;
        }
        if (this.props.idx === this.props.playingVideoIdx ||
            this.props.idx === this.props.nextVideoIdx) {
            if (videoPlay === 'hover' || videoPlay === 'auto') {
                return true;
            }
            else if (itemClick === 'nothing') {
                return true;
            }
            else if (itemClick === 'link' && !hasLink) {
                return true;
            }
        }
        return false;
    };
    VideoItemWrapper.prototype.createVideoItemPlaceholder = function (showVideoControls) {
        var props = utils.pick(this.props, [
            'alt',
            'title',
            'description',
            'id',
            'idx',
            'styleParams',
            'createUrl',
            'settings',
            'actions',
        ]);
        return (React.createElement(VideoItemPlaceholder, __assign({}, props, { key: "videoPlaceholder", imageDimensions: this.props.imageDimensions, isThumbnail: !!this.props.thumbnailHighlightId, id: this.props.idx, videoControls: showVideoControls && videoControls })));
    };
    VideoItemWrapper.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var VideoItem, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, import(
                            /* webpackChunkName: "proGallery_videoItem" */ './videoItem')];
                    case 1:
                        VideoItem = _a.sent();
                        this.VideoItem = VideoItem.default;
                        if (this.shouldPlayVideo()) {
                            this.setState({ VideoItemLoaded: true });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error('Failed to fetch VideoItem');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VideoItemWrapper.prototype.render = function () {
        var hover = this.props.hover;
        var showVideoControls = !this.props.hidePlay && this.props.styleParams.showVideoPlayButton;
        var videoPlaceholder = this.createVideoItemPlaceholder(showVideoControls);
        var VideoItem = this.VideoItem;
        if (!this.shouldPlayVideo() || !VideoItem) {
            return [videoPlaceholder, hover];
        }
        return (React.createElement(VideoItem, __assign({}, this.props, { videoControls: showVideoControls && videoControls })));
    };
    return VideoItemWrapper;
}(ImageItem));
export default VideoItemWrapper;
//# sourceMappingURL=videoItemWrapper.js.map